import React, {CSSProperties} from "react"
import styles from './CopyrightNotice.module.scss'

const year = new Date().getFullYear()

export const CopyrightNotice = ({style}: {style?: CSSProperties}) =>  {

    return <p data-testid='copyright-notice' className={styles['copyright-notice']} style={style}>
        COPYRIGHT © {year} Thermo Fisher Scientific Inc. All Rights Reserved.
    </p>
}
